import { v4 as uuidv4 } from 'uuid'

export const poFormats = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Format ' + ++index,
  __typename: 'POFormat'
}))
